<template>
  <div class="container-box">
    <el-table :data="info.passengerInfo" border max-height="400px" size="mini">
      <el-table-column label="乘客信息" align="center" prop="passengerInfo">
        <template slot-scope="{ row }">
          <yd-link
            v-if="userList.includes(row.passengerMobilePhone)"
            permi="user_center_manage"
            :value="row.passengerInfo"
            :url="phoneUrl(info, row.passengerMobilePhone)"
            type="userInfo"
          />
          <span v-else>{{ row.passengerInfo }}</span>
        </template>
      </el-table-column>
      <el-table-column label="证件" align="center" prop="idCard" />
      <el-table-column label="座位号" align="center" prop="seatName" width="60" />
      <el-table-column label="车票状态" align="center" prop="ticketState" width="70" />
      <el-table-column label="发票状态" align="center" prop="invoiceState" width="70" />
      <el-table-column label="购票类型" align="center" prop="orderTicketType" width="80">
        <template slot-scope="{ row }">
          <el-tooltip
            effect="dark"
            :content="row.childName ? '乘车儿童姓名：' + row.childName : row.passengerName"
            placement="right"
          >
            <div>{{ row.orderTicketType }}</div>
          </el-tooltip>
          <div v-if="row.orderTicketType === '成人' && row.isEr">(儿童全价)</div>
        </template>
      </el-table-column>
      <el-table-column label="座位费" align="center" prop="seatAmount" width="70" />
      <el-table-column label="支付金额" align="center" prop="payAmount" width="70" />
      <el-table-column label="改签违约金" align="center" prop="changedPoundage" width="60" />
      <el-table-column label="退票违约金" align="center" prop="refundPoundage" width="60" />
      <el-table-column label="已退金额" align="center" prop="returnedAmount" width="70" />
      <el-table-column label="剩余金额" align="center" prop="surplusAmount" width="70" />
      <el-table-column label="退票时间" align="center" prop="refundTime" />
      <el-table-column label="退票入口" align="center" prop="refundEntry" />
      <!-- <el-table-column label="乘客双码" align="center" width="130">
        <template slot-scope="scope">
          <div
            v-if="
              scope.row.passengerHealthyAndTravelCode &&
              scope.row.passengerHealthyAndTravelCode.healthyCodeUrl !== '-' &&
              scope.row.passengerHealthyAndTravelCode.travelCodeUrl !== '-'
            "
          >
            <img
              width="30px"
              style="margin-right: 20px"
              :src="scope.row.passengerHealthyAndTravelCode.healthyCodeUrl"
              :key="index"
              @click="openPreview(index, scope.row.passengerHealthyAndTravelCode.healthyCodeUrl)"
            />
            <img
              width="30px"
              style="margin-right: 20px"
              :src="scope.row.passengerHealthyAndTravelCode.travelCodeUrl"
              :key="index"
              @click="openPreview(index, scope.row.passengerHealthyAndTravelCode.travelCodeUrl)"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column label="司机双码" align="center" width="130">
        <template slot-scope="scope">
          <div
            v-if="
              scope.row.driverHealthyAndTravelCode &&
              scope.row.driverHealthyAndTravelCode.healthyCodeUrl !== '-' &&
              scope.row.driverHealthyAndTravelCode.travelCodeUrl !== '-'
            "
          >
            <img
              width="30px"
              style="margin-right: 20px"
              :src="scope.row.driverHealthyAndTravelCode.healthyCodeUrl"
              @click="openDriverPreview(index, scope.row.driverHealthyAndTravelCode.healthyCodeUrl)"
            />
            <img
              width="30px"
              style="margin-right: 20px"
              :src="scope.row.driverHealthyAndTravelCode.travelCodeUrl"
              @click="openDriverPreview(index, scope.row.driverHealthyAndTravelCode.travelCodeUrl)"
            />
          </div>
        </template>
      </el-table-column> -->
      <el-table-column label="操作" align="center" width="80">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="handleReset(scope.row.orderTicketId, scope.row.invoiceStateCode)"
            v-has-permi="['order_intercity_resetTickt']"
            :loading="invoiceResetLoading"
          >
            开票重置
          </el-button>
          <div v-if="scope.row.ticketState === 4">
            <!-- | -->
            <el-popover placement="right" width="600" trigger="click">
              <el-table :data="refundData" border size="mini" height="220">
                <el-table-column label="编号" align="center" prop="ticketId" />
                <el-table-column width="100" align="center" label="退款时间" />
                <el-table-column width="100" align="center" label="退款金额（元）" />
                <el-table-column width="100" align="center" label="退款类型" />
                <el-table-column width="100" align="center" label="扣除手续费(元)" />
                <el-table-column width="100" align="center" label="审核状态" />
                <el-table-column width="100" align="center" label="操作人" />
                <el-table-column property="name" align="center" label="备注" />
              </el-table>
            </el-popover>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import { reset, resetVerification } from '@/api/invoice'
  import { phoneUrl } from '../utils'

  export default {
    name: 'passengerInfo',
    props: {
      info: {},
      orderId: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        healthCodes: [],
        invoiceResetLoading: false
      }
    },
    computed: {
      userList() {
        const { userMap } = this.info || {}
        return Object.keys(userMap || {}) || []
      },
      phoneUrl() {
        return phoneUrl
      }
    },
    methods: {
      async handleReset(orderTicketId, state) {
        this.invoiceResetLoading = true

        const { code } = await resetVerification(this.orderId)

        if (code === 0) {
          this.invoiceReset(orderTicketId, state)
        }

        this.invoiceResetLoading = false
      },
      invoiceReset(orderTicketId, state) {
        const loading = this.$loading({})
        let text = '确定将发票重置吗?'
        if (state === 2) {
          text = '确定将发票重置吗?'
        } else if (state === 3) {
          text = '请确认线下开票已收回'
        }
        this.$confirm(text, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            // state === 2 ? this.getReset(orderTicketId, state) : console.log(123456778)
            this.getReset(orderTicketId, state)
          })
          .then(() => {
            loading.close()
            this.$emit('refreshData')
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: '已取消'
            })
          })
      },
      getReset(orderTicketId, state) {
        reset(orderTicketId, state).then((res) => {
          const { code, msg } = res
          if (code === 0) {
            this.$message.success('操作成功')
            this.$emit('refreshData')
          }
          if (code !== 0) {
            this.$message.error(msg)
          }
        })
      },
      // 预览乘客码
      openPreview(index = 0, row) {
        this.healthCodes = []
        this.healthCodes.push({ thumbUrl: row, url: row })
        this.$ImagePreview(this.healthCodes, index, {
          closeOnClickModal: true,
          beforeClose: () => {
            this.$message.success('关闭回调')
          }
        })
      },
      // 预览司机码
      openDriverPreview(index = 0, row) {
        this.driveHealthCodes = []
        this.driveHealthCodes.push({ thumbUrl: row, url: row })
        this.$ImagePreview(this.driveHealthCodes, index, {
          closeOnClickModal: true,
          beforeClose: () => {
            this.$message.success('关闭回调')
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .container-box {
    margin: 12px 0 30px 0;
    padding: 0 10px;
  }
</style>
